import * as React from 'react'

type ReturnValue<T> = [state: T, setState: React.Dispatch<React.SetStateAction<T>>, stateRef: React.MutableRefObject<T>]

export const useStateRef = <T>(initialState: any): ReturnValue<T> => {
  const [state, setStateValue] = React.useState<T>(initialState)

  const stateRef = React.useRef(state)

  const setState: React.Dispatch<React.SetStateAction<T>> = (newValue) => {
    setStateValue((prev) => {
      return typeof newValue === 'function' ? (newValue as (prevState: T) => T)(prev) : newValue
    })
  }

  React.useEffect(() => {
    stateRef.current = state
  }, [state])

  return [state, setState, stateRef]
}
